module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/pppcommission005#toc"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('i', [_vm._v("“Yet the way men live is so far removed from the way they ought to live that anyone who abandons what is for what should be pursues his downfall rather than his preservation; for a man who strives after goodness in all his acts is sure to come to ruin, since there are so many men who are not good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Niccolo Machiavelli,")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_c('i', [_vm._v("The Prince")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da45b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ppp-commission007.vue
// module id = 75
// module chunks = 0